<template>
    <div class="font">
        <v-row class="extra-bottom-area">
            <v-col>
                <div class="stage-title">{{stage.Name && stage.Name.toUpperCase()}}</div>
                <v-form ref="form">
                    <div v-for="(q) in questions" :key="q.Id">
                        <apply-upload
                            v-if="!q.Parent_Question__c && q.Type__c === 4"
                            :question="q.Question_Text__c"
                            :answer="q['Answer__c.Answer__c']"
                            :helper_text="q.Helper_Text__c"
                            :required="q['Required__c']"
                            :qid="q.Id"
                            :aid="q['Answer__c.Id']"
                            :application_id="application_id"
                            :stageId="stage_key"
                            @upload-begin="uploading = true"
                            @upload-over="uploading = false"
                        ></apply-upload>
                    </div>
                </v-form>
            </v-col>
        </v-row>
        <v-row class="sticky-footer" justify="center" align="center">
            <v-col cols="12" sm="3" md="3" lg="2">
                <v-btn class="button btn-font" outlined @click="gotoDashboard" color="#4d4d4d" large>BACK</v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="4">
                <v-btn class="button btn-font" :disabled="loading" @click="save" color="#ea7f1d" large>{{loading? 'SAVING...' : 'SAVE RESPONSES'}}</v-btn>
            </v-col>
        </v-row>
        <!-- <div v-if="uploading" class="loadings"> -->
            <v-dialog
                v-model="uploading"
                elevation="2"
                min-width="300"
                max-width="400"
                persistent
            >
                <div class="loadings">
                    <div class="loadings-message">Please wait while your file uploads...</div>
                    <v-progress-linear
                        color="#ea7f1d"
                        rounded
                        indeterminate
                    ></v-progress-linear>
                </div>
            </v-dialog>
        <!-- </div> -->
    </div>
</template>
<script>
// import StepMulti from "./StepMultiComponent";
// import StageBottomBar from './StageBottomBarComponent';
import ApplyUpload from './ApplyUploadComponent';
// import axios from 'axios'
import Client from '../client.js'

export default {
    props: {
        stage_key: String,
        sort: [String, Number],
        application_id: [String, Number]
    },
    components: {
        ApplyUpload,
    },
    computed: {
        stage() {
            const stages = this.$store.getters['stage/stages'];
            if(stages.length === 0) return {};
            return stages.find(s => s.Id === this.stage_key);
        },
        questions() {
            const questionsWithAnswer = this.$store.getters['stage/questionsWithAnswer'];
            if(!questionsWithAnswer[this.stage_key]) return [];
            return questionsWithAnswer[this.stage_key];
        },
    },
    data: function () {
        return {
            loading: false,
            uploading: false,
        }
    },
    methods: {
        validate() {
            return this.$refs.form.validate();
        },
        async save() {
            // if(!this.validate()) return;
            // this.loading = true;
            // setTimeout(() => {
            //     this.loading = false;
            //     this.$router.push({name: 'application.dashboard'})
            // }, 1000)
            const status = this.validate() ? 'Completed' : 'In Progress';
            const client = Client();
            client.post(`/stages/${this.stage_key}/status`, {
                Stage__c: this.stage_key,
                Scholarship_Application__c: this.application_id,
                Status__c: status,
            }).then(() => {
                this.$store.commit('stage/updateStageStatus', {stageId: this.stage_key, status})
            })
            this.$router.push({name: 'application.dashboard'})
        },
        // updateAnswer({qid, answer, answerId}) {
        //     this.$store.commit('stage/updateAnswer', {stageId: this.stage_key, questionId: qid, answer, answerId});
        // },
        gotoDashboard() {
            // this.$store.dispatch('stage/fetchStages', {appId: this.application_id});
            this.$router.push({name: 'application.dashboard'});
        }
    }
}
</script>
<style lang="scss" scoped>
.helper_text-wrapper {
    text-align: center;
    width: 100%;
    color: $go-dark-grey;
    margin-bottom: 10px;
}

.stage-image-position {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;
}

.centered {
    margin-left: auto;
    margin-right: auto;
    display: block;
    width: 70%
}
.stage-title {
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    font-family: $body-font-family;
    margin-bottom: 28px;
}
.font {
    font-family: $secondary-font;
}
.sticky-footer {
    box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.2);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 100;
}
.button {
    width: 100%;
    color: white;
    font-family: $btn-font;
}
.extra-bottom-area {
    margin-bottom: 120px;
}
.loadings {
    background-color: white;
    padding: 10px;
}
.loadings-message {
    font-family: $secondary-font;
    margin-bottom: 5px;
    text-align: center;
}
</style>
